export const FIELD_LABEL_GROUPS: Record<string, string[]> = {
  Outcome: [
    "Business Objective Name",
    "Description",
    "Business Tactic Name",
    "Business To-Do Name",
  ],
  "Account Objective": ["Account Objective Name"],
  "Tactic Name": ["Account Tactic Name", "Outcome Tactic Name"],
  "To-Do Name": ["To-Do Name"],
  "Outcome Name": ["Business Outcome Name", "Outcome Name"],
  "Question & Response": [
    "Question & Response",
    "Question Response",
    "Question Response Text",
  ],
  "Short Description": ["Short Description"],
  Strengths: ["Strength", "Strengths"],
  Weaknesses: ["Weakness", "Weaknesses"],
};

const labelsByNormalizedValue = Object.fromEntries(
  Object.entries(FIELD_LABEL_GROUPS).flatMap(([label, values]) =>
    values.map((value) => [value.toLowerCase(), label]),
  ),
);

export const aggregateFieldLabel = (value: string): string =>
  labelsByNormalizedValue[value.trim().replace(/\s+/g, " ").toLowerCase()] ||
  value;

export const aggregateFieldLabelOptions = (values: string[] = []): string[] =>
  Array.from(new Set(values.map(aggregateFieldLabel))).sort((a, b) =>
    a.localeCompare(b),
  );

export const expandFieldLabelFilters = (values: string[] = []): string[] =>
  Array.from(
    new Set(values.flatMap((value) => FIELD_LABEL_GROUPS[value] || [value])),
  );
